













import { Component, Prop, Vue } from 'vue-property-decorator';
import { PopupList } from '@/constants/utils';
import PopupTrigger from '@/components/Popup/PopupTrigger.vue';

@Component({
	components: {
		PopupTrigger
	}
})
export default class ActeurPastille extends Vue {
	@Prop({ required: true })
	acteur!: string;

	get acteurColor(): any {
		return this.$store.getters.getActeurColor(this.acteurName());
	}

	private acteurName(): string {
		const options = this.$options as any;
		if (typeof this.$options !== 'undefined') {
			return options.filters.dynamicList(this.acteur);
		} else {
			return this.acteur;
		}
	}

	private List(text: string): any {
		return PopupList(text);
	}
}
